export default "__VITE_ASSET__f0d14b62__"